<template>
    <div>
      <div class="tip_info" v-show="succshow">
        <i class="iconfont wait_icon" v-show="show">&#xe645;</i>
        <i class="iconfont succ_icon" v-show="!show">&#xe64f;</i>
        <p class="tip_desc">{{succtip}}</p>
      </div>
      <div class="tip_info" v-show="!succshow">
        <i class="iconfont tip_icon">&#xe738;</i>
        <p class="tip_desc">{{failtip}}</p>
      </div>
      <!-- <button v-show="!succshow" @click="TryPayClick">再次提交</button> -->
    </div>
</template>

<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  name: 'PayTip',
  data () {
    return {
      code: '',
      AppId: '',
      succtip: '',
      failtip: '',
      show: true,
      succshow: true
    }
  },
  methods: {
    GetQueryString (name) {
      let url = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let newUrl = window.location.search.substr(1).match(url)
      if (newUrl != null) {
        return unescape(newUrl[2])
      } else {
        return false
      }
    },
    // 获取OPENID
    getWeixinOpenIDAndPay (code) {
      let vm = this
      axios.get('/ApiMe/AccountDeposit', {
        headers: {
          'Authorization': localStorage.token
        },
        params: {
          code: this.code, // 页码
          amount: this.$route.query.amount
        }
      }).then(function (res) {
        console.log(res)
        res = res.data
        if (res.errorInfo === '') {
          let wxpay = JSON.parse(res.data.wxpay)
          // 调用微信支付接口
          vm.Pay(wxpay)
        } else {
          // 失败
          alert(res.errorInfo)
          vm.succshow = false
          vm.failtip = res.errorInfo
          // vm.$router.push({
          //   path: '/wechat_pay'
          // })
        }
      })
    },
    Pay (data) {
      this.succtip = '支付平台连接中...'
      this.show = false
      let vm = this
      // 获取后台传入的数据
      let appId = data.appid
      let timestamp = data.timeStamp
      let nonceStr = data.nonceStr
      let signature = data.signature
      let packages = data.package
      let paySign = data.paySign
      let signType = data.signType
      console.log('发起微信支付')
      // 微信支付配置
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      // 发起请求
      wx.ready(function () {
        wx.chooseWXPay({
          timestamp: timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
          package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: paySign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数
            vm.succtip = '支付成功'
            alert('支付成功')
            vm.$router.push({
              path: '/me'
            })
            // cb(res)
          },
          fail: function (res) {
            // 失败回调函数
            alert(res)
            // errorCb(res)
          }
        })
      })
      // 错误
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        /* alert("config信息验证失败"); */
      })
    }
    // TryPayClick () {
    //   let vm = this
    //   vm.$router.push({
    //     path: '/wechat_pay'
    //   })
    // }
    // 微信支付接口-老接口
    // OldPay (data) {
    //   let vm = this
    //   if (typeof WeixinJSBridge === 'undefined') {
    //     if (document.addEventListener) {
    //       document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
    //     } else if (document.attachEvent) {
    //       document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
    //       document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
    //     }
    //   } else {
    //     vm.onBridgeReady(data)
    //   }
    // },
    // onBridgeReady (data) {
    //   // let self = this
    //   WeixinJSBridge.invoke(
    //     'getBrandWCPayRequest', {
    //       'appId': data.appid,
    //       'timeStamp': data.timeStamp, // 这里必须要转换为字符串。ios跟android表现不同。后台返回的是数值，但是微信方面必须要json参数都是字符串形式，android会自动转换成字符串（当时我在这里也找了很久的博文才知道的）
    //       'nonceStr': data.nonceStr,
    //       'package': data.package,
    //       'signType': data.signType,
    //       'paySign': data.paySign
    //     },
    //     function (res) {
    //       if (res.err_msg === 'get_brand_wcpay_request:ok') {
    //         alert('成功啦')
    //         // self.$router.replace({name: 'paymentend'})
    //       } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
    //         alert('支付取消')
    //         // self.$vux.toast.text('支付取消!', 'default')
    //       } else {
    //         alert('支付失败')
    //         // self.$vux.toast.text('支付失败!', 'default')
    //       }
    //     }
    //   )
    // }
  },
  mounted () {
    this.succtip = '与微信支付平台建立连接中...'
    let vue = this
    console.log('token:' + localStorage.token)
    // 判断是否获取到CODE
    if (!this.GetQueryString('code')) {
      // 获取APPID
      axios.get('/ApiMe/GetDepositModel')
        .then(function (res) {
          res = res.data
          console.log(res)
          // console.log(JSON.parse(res.data.body).appid)
          if (res.ret) {
            vue.AppId = JSON.parse(res.data.body).appid
            let currentUrl = encodeURIComponent(window.location.href)
            window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + vue.AppId + '&redirect_uri=' + currentUrl + '&response_type=code&scope=snsapi_base&state=lk#wechat_redirect'
          } else {
            this.$router.push({
              path: '/log_on'
            })
          }
        })
    } else {
      this.code = this.GetQueryString('code')
      this.getWeixinOpenIDAndPay(this.code)
    }
  }
}
</script>

<style scoped>
.tip_info{ display: flex; flex-direction: column; align-items: center; padding: 70px 0 30px;}
.wait_icon{ color: #ff6700; font-size: 50px; margin-bottom: 10px;}
.succ_icon{ color: #00bc0c; font-size: 50px; margin-bottom: 10px;}
.tip_icon{ color: #f00; font-size: 50px; margin-bottom: 10px;}
.tip_desc{ text-align: center; font-size: 16px;}
button{ background: #f00; border: 0; color: #fff; width: 80%; display: block; margin: 0 auto; padding: 10px; margin-top: 20px; border-radius: 3px;}
</style>



// WEBPACK FOOTER //
// src/pages/wechat_pay/components/Tip.vue